<!-- <div
*ngIf="treeList.length"
class="bg noselect items"
style="position: relative;"
[style.width.px]="100">
<poc-component
  [showHiddenListGroup]="showHiddenListGroup"
  [treeList]="treeList"
  [report_execution_id]="report_execution_id"
  (updateUiTreeEvent)="updateUiTree($event)"
  (resetTreeEvent)="resetTreeNode($event)"
  (updateTreeEvent)="updateTreeNode($event)"
  >
</poc-component>
</div> -->

@if (!showZeroState ) {
<div style="display: flex;
flex-direction: row;height: 180px;overflow: hidden;"
[ngClass]="{'h-[299px]': isFromHomePage}">
    @for (tree of tree; track tree; let i = $index) {
      <node [name]="tree.name"  [owner_type]="tree.owner_type" [position_value]="tree.position_value"  [owner_profile_image_path]="tree.owner_profile_image_path" [children]="tree.children"> </node>
    }
  </div>
}


@if (showZeroState ) {
  <img  class="mobiel-image" src="assets/images/zero-state-map.svg"/>
}